import promise from 'promise';

import api from 'app/shared/utils/api';

const ApplicationActions = {
    enableApplications() {
        return dispatch => dispatch(api.users.applications.enableApplications())
            .then((response = {}) => {
                if (response.success === false) {
                    return promise.reject(response.error);
                }
                return response;
            }).catch(err => promise.reject(err));
    },
};

export default ApplicationActions;
